
export default class Footer {

	static getHolderSelectors = () => ['footer'];

	/** @type {HTMLElement} */
	#element;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#element = holderElement;
		if (holderElement.dataset.instagram) {
			void this.#loadInstagram();
		}
	}

	async #loadInstagram() {
		const baseUrl = `/instagram/${this.#element.dataset.instagram}`;
		const feedUrl = `${baseUrl}/feed.json`;
		const response = await fetch(feedUrl);
		if (!response.ok) {
			console.warn(`Could not get Instagram feed. HTTP status: ${response.status}`);
			return;
		}
		const feed = await response.json();
		const slides = [];
		let count = 0;
		for (const filename of feed) {
			if (count > 4) {
				break;
			}
			const img = document.createElement('img');
			img.src = `${baseUrl}/${filename}`;
			img.loading = 'lazy';

			const li = document.createElement('li');
			li.classList.add('splide__slide');
			li.append(img);
			slides.push(li);
			count++;
		}
		this.#element.querySelector('.splide__list').append(...slides);

		const slider = new Splide(this.#element.querySelector('.splide'), {
			type: 'loop',
			gap: '3.2rem',
			arrows: false,
			pagination: false,
			perPage: 3,
			breakpoints: {
				992: {
					perPage: 2,
					gap: '1rem',
				}
			}
		});
		slider.mount();
		const sliderControls = this.#element.querySelectorAll('[data-slider-control]');
		sliderControls.forEach(sliderControl => {
			sliderControl.addEventListener('click', () => {
				slider.go(sliderControl.dataset.sliderControl);
			});
		});
	}

}
